import { Area } from "./entities/Area";

const actions = {
  criar: async (context, { unidadeId, nome }) => {
    const api = context.rootState.autenticacao.api;

    await api.post(`/org/unidade/${unidadeId}/area`, {
      unidadeId: unidadeId,
      nome: nome,
    });
  },

  listar: async (context, { unidadeId }) => {
    const api = context.rootState.autenticacao.api;

    let resposta = await api.get(`/org/unidade/${unidadeId}/area`, {
      unidadeId: unidadeId,
    });

    resposta = resposta.data;

    let listaArea = [];
    resposta.resultado.dados.forEach((areaDTO) => {
      listaArea.push(
        new Area({
          areaId: areaDTO.areaId,
          unidadeId: areaDTO.unidadeId,
          nome: areaDTO.nome,
        })
      );
    });

    return {
      listaArea,
    };
  },

  excluirArea: async (context, { unidadeId, areaId }) => {
    const api = context.rootState.autenticacao.api;
    let resposta = await api.delete(`/org/unidade/${unidadeId}/area/${areaId}`);

    return resposta;
  },
};

export const area = {
  namespaced: true,
  actions,
};
